module.exports = __webpack_public_path__ + "img/portrait_960.4dda1c13.jpg";